import { fetchWrapper } from "@/helpers/fetch-wrapper";

const API_URL = process.env.VUE_APP_SERVER_URL;

export const getGalleries = () => fetchWrapper.get(`${API_URL}/api/galleries?populate=*`);
